import { render, staticRenderFns } from "./B2CKeyword.vue?vue&type=template&id=c8bfb13a"
import script from "./B2CKeyword.vue?vue&type=script&lang=js"
export * from "./B2CKeyword.vue?vue&type=script&lang=js"
import style0 from "./B2CKeyword.vue?vue&type=style&index=0&id=c8bfb13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports